import { render, staticRenderFns } from "./MenuAlineacionesCampbell.vue?vue&type=template&id=6555823a&scoped=true"
import script from "./MenuAlineacionesCampbell.vue?vue&type=script&lang=js"
export * from "./MenuAlineacionesCampbell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6555823a",
  null
  
)

export default component.exports